// Week 1 / Day 2 — Budget and Account: In, Out, Left.
// Reworked: bilingual RU/EN inline; playful Nimny mission tone;
// 50% online + 50% paper/parent. Five layers preserved.

const day2 = {
  id: 'day-2',
  studentId: 'max',
  weekId: 'week-1',
  dayId: 'day-2',
  status: 'active',
  title: 'Бюджет и счёт: пришло, ушло, осталось / Budget and Account: In, Out, Left',
  shortTitle: 'Бюджет и счёт / Budget and Account',
  theme:
    'Баланс показывает, сколько осталось после того, как нимы пришли или ушли. / A balance shows what is left after nims come in or go out.',
  estimatedTimeLabel:
    'Онлайн-миссия: около 20–30 минут. Бумажная миссия с родителем: около 25–35 минут. / Online mission: about 20–30 minutes. Paper mission with parent: about 25–35 minutes.',
  nimnyIntro:
    'Нимни нашла Баланс-тропу. На ней есть карточки «пришло», «ушло» и «осталось». Помоги Нимни пройти тропу и не потерять счёт. / Nimny found the Balance Path. It has cards: "came in", "went out" and "left". Help Nimny walk the path and keep the record.',
  goals: [
    'Слой 1. Математика: считать баланс по шагам и составлять простые таблицы доходов и расходов. / Layer 1. Math: track a balance step by step and build simple income/expense tables.',
    'Слой 2. Русский язык и правописание: словарь баланса, мини-диктант, парные согласные или повторение Дня 1. / Layer 2. Russian language and spelling: balance vocabulary, mini-dictation, paired consonants or Day 1 review.',
    'Слой 3. Чтение, письмо и пересказ: «Что такое баланс?» — план, пересказ и 3–5 предложений. / Layer 3. Reading, writing and retelling: "What is balance?" — plan, retell and 3–5 sentences.',
    'Слой 4. Наблюдение и логика — движение нимов. / Layer 4. Observation and Logic — How Nims Move.',
    'Слой 5. Практика на бумаге: «Баланс-тропа» и две коробочки — «на каждый день» и «на цель». / Layer 5. Paper practice: "Balance Path" and two boxes — "everyday" and "goal".',
    'Дневник мышления: одно открытие про баланс. / Thinking diary: one balance insight.',
    'Награда нимами: базово 3 нима, максимум 5 с бонусами. / Reward in nims: 3 base, up to 5 with bonuses.'
  ],
  vocabulary: [
    { term: 'доход / income', definition: 'нимы, которые пришли. / nims that came in.' },
    { term: 'расход / expense', definition: 'нимы, которые ушли. / nims that went out.' },
    { term: 'остаток / remaining', definition: 'сколько нимов осталось. / how many nims are left.' },
    { term: 'баланс / balance', definition: 'число остатка после всех событий. / the remaining number after all events.' },
    { term: 'счёт / account', definition: 'место, где ведётся запись нимов. / a place where the record of nims is kept.' },
    { term: 'запись / record', definition: 'короткая отметка о доходе или расходе. / a short note about income or expense.' },
    { term: 'пришло / came in', definition: 'нимы добавились. / nims were added.' },
    { term: 'ушло / went out', definition: 'нимы убавились. / nims were taken away.' },
    { term: 'отложить / set aside', definition: 'нимы сохранены на цель. / nims saved for a goal.' },
    { term: 'проверить / check', definition: 'сравнить таблицу с итогом. / compare the table with the total.' }
  ],
  onlineTasks: [
    {
      id: 'q_w1',
      type: 'math',
      title: 'Разогрев 1 / Warm-up 1',
      prompt:
        'Десятичный счёт: 12.5 + 7.5 − 4.25 = ? / Decimal warm-up: 12.5 + 7.5 − 4.25 = ?',
      helper:
        'Сначала 12.5 + 7.5 = 20, потом 20 − 4.25. / First 12.5 + 7.5 = 20, then 20 − 4.25.',
      answer: '15.75',
      unit: 'нимов / nims'
    },
    {
      id: 'q_w2',
      type: 'math',
      title: 'Разогрев 2 / Warm-up 2',
      prompt: 'Десятичный счёт: 0.75 × 8 = ? / Decimal warm-up: 0.75 × 8 = ?',
      helper: '0.75 — это 3/4; 3/4 от 8 = 6. / 0.75 equals 3/4; 3/4 of 8 = 6.',
      answer: '6',
      unit: 'нимов / nims'
    },
    {
      id: 'q1',
      type: 'math',
      title: 'Десятичный баланс / Decimal balance',
      prompt:
        'На счёт пришло 125.50 нимов и ещё 38.25 нимов. Потом ушло 46.80 и 12.40. Какой баланс? / Account received 125.50 and 38.25 nims. Then 46.80 and 12.40 went out. What is the balance?',
      helper:
        'Что сделать: сложи приходы, сложи расходы, потом вычти. Ответ — десятичная дробь. / What to do: sum incomes, sum expenses, subtract. Answer is a decimal.',
      answer: '104.55',
      unit: 'нимов / nims'
    },
    {
      id: 'q2',
      type: 'math',
      title: 'Дроби от дохода / Fractions of income',
      prompt:
        'Нимни получила 180 нимов. 2/5 она откладывает. Из остатка 1/3 тратит на материалы. Сколько нимов осталось? / Nimny earned 180 nims. She saves 2/5. From the remainder she spends 1/3 on materials. How many nims are left?',
      helper:
        'Что сделать: 1) найди 2/5 от 180 и вычти; 2) от нового остатка найди 1/3 и снова вычти. / What to do: 1) take 2/5 of 180 and subtract; 2) take 1/3 of the new remainder and subtract again.',
      answer: '72',
      unit: 'нимов / nims'
    },
    {
      id: 'q3',
      type: 'math',
      title: 'Уравнение с процентом / Percent equation',
      prompt:
        'Цена предмета с комиссией 15% стала 92 нима. Какая была цена без комиссии? / With a 15% fee the item costs 92 nims. What was the price before the fee?',
      helper:
        'Что сделать: цена + 15% = 92, т.е. 1.15x = 92. Найди x. / What to do: x + 0.15x = 92, so 1.15x = 92. Solve for x.',
      answer: '80',
      unit: 'нимов / nims'
    },
    {
      id: 'q_s1',
      type: 'math',
      title: 'Растяжка 1 / Stretch 1',
      prompt: 'Найди 1/10 от 250 нимов. / Find 1/10 of 250 nims.',
      helper: '1/10 — это деление на 10. / 1/10 means divide by 10.',
      answer: '25',
      unit: 'нимов / nims'
    },
    {
      id: 'q_s2',
      type: 'math',
      title: 'Растяжка 2 / Stretch 2',
      prompt: 'Найди 7.5% от 200 нимов. / Find 7.5% of 200 nims.',
      helper: '10% от 200 = 20; 5% = 10; 7.5% = 15 (или 7.5/100 × 200). / 10% = 20; 5% = 10; 7.5% = 15.',
      answer: '15',
      unit: 'нимов / nims'
    },
    {
      id: 'q4',
      type: 'classify',
      title: 'Слова баланса: парные согласные / Balance words: paired consonants',
      prompt:
        'Какая парная согласная пишется в корне? Используй проверочное слово. / Which paired consonant is in the root? Use a check word.',
      categories: [
        { id: 'voiced', label: 'звонкая / voiced' },
        { id: 'voiceless', label: 'глухая / voiceless' }
      ],
      items: [
        { id: 'rybka', text: 'рыбка — проверка: рыбы / "рыбка" — check: рыбы' },
        { id: 'lozhka', text: 'ложка — проверка: ложечка / "ложка" — check: ложечка' },
        { id: 'shapka', text: 'шапка — проверка: шапочка / "шапка" — check: шапочка' },
        { id: 'kniga', text: 'книга — проверка: книги / "книга" — check: книги' },
        { id: 'snezhinka', text: 'снежинка — проверка: снег / "снежинка" — check: снег' },
        { id: 'ostatok', text: 'остаток — проверка: остаточек / "остаток" — check: остаточек' }
      ]
    },
    {
      id: 'q5',
      type: 'text',
      title: 'Мини-диктант / Mini-dictation',
      prompt:
        'Запиши без ошибок: «Баланс показывает, сколько нимов осталось. Если записывать доходы и расходы, легче делать выбор.» / Write without mistakes: "Balance shows how many nims are left. If we write down income and expenses, it is easier to choose."',
      placeholder:
        'Баланс показывает, сколько нимов осталось. ... / Balance shows ...'
    },
    {
      id: 'q_corr',
      type: 'text',
      title: 'Исправь ошибки / Correct the mistakes',
      prompt:
        'Перепиши без ошибок: «балланс показывает скольк нимов асталось. Еслi записывать дохады и расходы лекче делать выбор.» Подсказки: «баланс» — одна «л»; «сколько» — мягкий знак; «осталось», «доходы», «легче» — безударные гласные проверяй ударением. / Rewrite: fix doubled letters, soft sign, unstressed vowels.',
      placeholder:
        'Баланс показывает, сколько нимов осталось. Если записывать доходы и расходы, легче делать выбор. / Balance shows ...'
    },
    {
      id: 'q6',
      type: 'text',
      title: 'План текста и письмо / Text plan and writing',
      prompt:
        'Прочитай короткий текст: «Счёт — это место, где ведут запись нимов. Когда нимы приходят, баланс растёт. Когда нимы уходят, баланс становится меньше. Чтобы видеть, сколько осталось, удобно записывать каждый шаг.» Запиши план из 3 пунктов и 3–5 предложений на русском по теме: «Почему полезно записывать доходы и расходы?» / Read the short text: "An account is a place where the record of nims is kept. When nims come in, the balance grows. When nims go out, the balance shrinks. To see what is left, it helps to write down each step." Write a 3-point plan and 3–5 Russian sentences.',
      placeholder:
        '1. ... 2. ... 3. ... Мои предложения: ... / 1. ... 2. ... 3. ... My sentences: ...'
    },
    {
      id: 'q_obs',
      type: 'text',
      title: 'Наблюдение и логика — движение нимов / Observation and Logic — How Nims Move',
      prompt:
        'Понаблюдай и запиши:\nЧто происходит, когда «пришло»? ____\nЧто происходит, когда «ушло»? ____\nЧто остаётся одинаковым на каждом шаге (правило баланса)? ____\nЧто меняется на каждом шаге? ____\nПример: 30 → +10 → 50 → −5 → 45 → +5 → 50. Где ошибка? ____ (подсказка: 30 + 10 = 40, не 50). / Observe nim movement: in / out / what stays the same / what changes. Find the mistake in the sample table.',
      placeholder:
        'Пришло: ... Ушло: ... Одинаково: ... Меняется: ... Ошибка в таблице: ... Вывод: ... / In: ... Out: ... Same: ... Changes: ... Mistake: ... Conclusion: ...'
    },
    {
      id: 'q7',
      type: 'classify',
      title: 'Карточки тропы: пришло / ушло / отложить / проверить / Path cards: in / out / save / check',
      prompt:
        'Распредели события по корзинам. / Sort the events into baskets.',
      categories: [
        { id: 'in', label: 'Пришло / Came in' },
        { id: 'out', label: 'Ушло / Went out' },
        { id: 'save', label: 'Отложить / Save' },
        { id: 'check', label: 'Проверить / Check' }
      ],
      items: [
        { id: 'gift10', text: 'подарок 10 нимов / a 10-nim gift' },
        { id: 'book18', text: 'купил книгу за 18 нимов / bought a book for 18 nims' },
        { id: 'save5', text: 'отложил 5 нимов на цель / saved 5 nims for a goal' },
        { id: 'snack6', text: 'купил закуску за 6 нимов / bought a snack for 6 nims' },
        { id: 'help8', text: 'нимы за помощь по дому 8 / 8 nims for helping at home' },
        { id: 'verify', text: 'сверил таблицу с итогом / checked the table against the total' }
      ]
    },
    {
      id: 'q8',
      type: 'text',
      title: 'Две коробочки / Two boxes',
      prompt:
        'Старт 40 нимов. Запиши: что положишь в коробку «на каждый день» и в коробку «на цель», сколько в каждой и одно правило проверки баланса. / Start 40 nims. Write: what goes into the "everyday" box and into the "goal" box, how many nims in each, and one rule to check the balance.',
      placeholder:
        'Каждый день: ... (____ нимов). На цель: ... (____ нимов). Правило проверки: ... / Everyday: ... ( ____ nims). Goal: ... ( ____ nims). Check rule: ...'
    },
    {
      id: 'q9',
      type: 'essay',
      title: 'Дневник мышления: моё открытие про баланс / Thinking diary: my balance insight',
      prompt:
        'Напиши 3–5 предложений: что я узнал про доход, расход и баланс и почему запись помогает. Используй слова: доход, расход, баланс, запись. / Write 3–5 sentences: what I learned about income, expense and balance, and why writing things down helps. Use words: income, expense, balance, record.',
      minSentences: 3,
      maxSentences: 5,
      placeholder:
        'Сегодня я понял ... / Today I understood ...'
    }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 1, День 2 — Баланс-тропа». / Heading: "Week 1, Day 2 — Balance Path".',
    'Слой 1. Математика: реши q1–q3, нарисуй таблицу баланса 5 шагов из q2. / Layer 1. Math: solve q1–q3 and draw the 5-step balance table from q2.',
    'Слой 2. Русский язык: запиши словарь баланса и мини-диктант. / Layer 2. Russian: write the balance vocabulary and the mini-dictation.',
    'Слой 3. Чтение и пересказ: 3-пунктовый план + 3–5 предложений; перескажи родителю. / Layer 3. Reading and retelling: 3-point plan + 3–5 sentences; retell to a parent.',
    'Слой 4. Наблюдение и логика: запиши, как меняется баланс после каждого события. / Layer 4. Observation and Logic: write how the balance changes after each event.',
    'Слой 5. Практика: запиши план двух коробочек. / Layer 5. Practice: write the two-box plan.',
    'Дневник мышления: одно открытие про баланс. / Thinking diary: one balance insight.',
    'Награда нимами начисляется после проверки родителем. / Reward in nims is added after a parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 1, День 2 / Week 1, Day 2',
    subtitle: 'Баланс-тропа Нимни / Nimny Balance Path',
    pages: [
      {
        title: 'Маршрут миссии — Баланс-тропа / Mission Route — Balance Path',
        blocks: [
          { type: 'text', text: 'Сегодня — пять слоёв и одна тропа. Отмечай ☐ → ☑. / Today — five layers and one path. Mark ☐ → ☑.' },
          { type: 'list', items: [
            '☐ Слой 1. Математика — около 10 минут. / Layer 1. Math — about 10 minutes.',
            '☐ Слой 2. Русский язык — около 10 минут. / Layer 2. Russian — about 10 minutes.',
            '☐ Слой 3. Чтение и пересказ — около 10 минут. / Layer 3. Reading and retelling — about 10 minutes.',
            '☐ Слой 4. Наблюдение и логика — около 5 минут. / Layer 4. Observation and Logic — about 5 minutes.',
            '☐ Слой 5. Практика на бумаге — около 15 минут. / Layer 5. Paper practice — about 15 minutes.',
            '☐ Дневник мышления — 5 минут. / Thinking diary — 5 minutes.',
            '☐ Печать миссии и награда нимами. / Mission stamp and nim reward.'
          ]}
        ]
      },
      {
        title: 'Слой 1. Математика — пришло, ушло, осталось / Layer 1. Math — In, Out, Left',
        blocks: [
          { type: 'text', text: 'Считай в нимах. Записывай шаги. / Count in nims. Show your steps.' },
          { type: 'list', items: [
            '1) Десятичный баланс: пришло 125.50 и 38.25; ушло 46.80 и 12.40. / Decimal balance.',
            '   Доходы: 125.50 + 38.25 = ____ . Расходы: 46.80 + 12.40 = ____ . Баланс = ____ − ____ = ____ нимов.',
            '2) Дроби: 180 нимов; 2/5 → отложить; от остатка 1/3 → материалы. / Fractions of income.',
            '   2/5 × 180 = ____ . Остаток 1 = 180 − ____ = ____ . 1/3 × ____ = ____ . Конечный остаток = ____ нимов.',
            '3) Уравнение: цена + 15% = 92. Найди x. / Equation with percent.',
            '   1.15x = 92  →  x = ____ нимов / nims.',
            '4) Warm-up: 50 + 20 − 15 − 5 + 10 = ____ ; 60 − 18 − 10 − 12 = ____ .',
            '5) Растяжка: 1/10 от 250 нимов = ____ ; 7.5% от 200 = ____ .'
          ]}
        ]
      },
      {
        title: 'Слой 2. Русский язык и правописание — слова баланса / Layer 2. Russian Language and Spelling — Balance Words',
        blocks: [
          { type: 'text', text: 'Правило дня: парные согласные в корне проверяем гласной (рыбка — рыбы). / Rule of the day: check paired consonants with a vowel (рыбка — рыбы).' },
          { type: 'list', items: [
            'Словарь миссии: доход, расход, остаток, баланс, счёт, запись, пришло, ушло, отложить, проверить. / Mission vocabulary.',
            'Мини-диктант: «Баланс показывает, сколько нимов осталось. Если записывать доходы и расходы, легче делать выбор.» / Mini-dictation.',
            'Запиши без ошибок: __________________________________________ / Write without mistakes:',
            'Исправление: «балланс показывает скольк нимов асталось. Еслi записывать дохады и расходы лекче делать выбор.» / Correct and rewrite the sentence with mistakes.',
            'Подчеркни парную согласную в словах: рыбка, ложка, остаток. / Underline the paired consonant.'
          ]}
        ]
      },
      {
        title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling',
        blocks: [
          { type: 'text', text: 'Прочитай короткий текст и сделай план. / Read the short text and make a plan.' },
          { type: 'list', items: [
            'Текст: «Счёт — это место, где ведут запись нимов. Когда нимы приходят, баланс растёт. Когда нимы уходят, баланс становится меньше. Чтобы видеть, сколько осталось, удобно записывать каждый шаг.» / Text: "An account is a place where..."',
            'План: 1) ____________________  2) ____________________  3) ____________________ / Plan',
            'Главная мысль: ______________________________________ / Main idea',
            'Мои 3–5 предложений «Почему полезно записывать доходы и расходы?»: / My 3–5 sentences',
            '1. ______________________________________________',
            '2. ______________________________________________',
            '3. ______________________________________________',
            '☐ Я пересказал родителю / I retold a parent.'
          ]}
        ]
      },
      {
        title: 'Слой 4. Наблюдение и логика — движение нимов / Layer 4. Observation and Logic — How Nims Move',
        blocks: [
          { type: 'text', text: 'Понаблюдай, как баланс меняется на каждом шаге. / Observe how the balance changes at each step.' },
          { type: 'list', items: [
            'Что происходит, когда «пришло»? ____________________ / What happens when "came in"?',
            'Что происходит, когда «ушло»? ____________________ / What happens when "went out"?',
            'Что остаётся одинаковым на каждом шаге? ____________________ / What stays the same at each step?',
            'Что меняется на каждом шаге? ____________________ / What changes at each step?',
            'Найди ошибку в таблице: 30 → +10 → 50 → −5 → 45 → +5 → 50. Где ошибка? ____________________ / Find the mistake in the sample table.',
            'Мой вывод (1 фраза): ____________________ / My conclusion (1 line):'
          ]}
        ]
      },
      {
        title: 'Слой 5. Практика на бумаге — Карточки Баланс-тропы и две коробочки / Layer 5. Paper Practice — Balance Path Cards and Two Boxes',
        blocks: [
          { type: 'text', text: 'Нарежь или отметь карточки. Пройди тропу из 5 шагов. / Cut or mark the cards. Walk the 5-step path.' },
          { type: 'list', items: [
            'Корзины: «Пришло», «Ушло», «Отложить», «Проверить». / Baskets: In, Out, Save, Check.',
            'Карточки: подарок 10, книга 18, отложить 5, закуска 6, помощь по дому 8, проверка таблицы. / Cards: gift 10, book 18, save 5, snack 6, chores 8, table check.',
            'Тропа баланса (старт 40 нимов): / Balance path (start 40 nims):',
            'Шаг 1: ____________________ → баланс ____',
            'Шаг 2: ____________________ → баланс ____',
            'Шаг 3: ____________________ → баланс ____',
            'Шаг 4: ____________________ → баланс ____',
            'Шаг 5: ____________________ → баланс ____',
            'Две коробочки (старт 40 нимов): / Two boxes (start 40 nims):',
            '☐ Коробка «На каждый день»: ____________________ (____ нимов) / "Everyday" box',
            '☐ Коробка «На цель»: ____________________ (____ нимов) / "Goal" box',
            'Моё правило проверки баланса: ____________________ / My check rule:'
          ]}
        ]
      },
      {
        title: 'Дневник мышления / Thinking Diary',
        blocks: [
          { type: 'list', items: [
            'Моё открытие про баланс: ______________________ / My balance insight today',
            'Я понял это, потому что _________________________ / I understood it because',
            'Слово миссии, которое запомнилось: ________________ / Mission word I remember'
          ]}
        ]
      },
      {
        title: 'Родительская проверка, печать миссии и награда нимами / Parent Check, Mission Stamp and Nim Reward',
        blocks: [
          { type: 'text', text: 'После проверки начисли бонусные нимы через Parent Room. / After checking, add bonus nims through Parent Room.' },
          { type: 'list', items: [
            'Базовая награда: 3 нима ☐ / Base reward: 3 nims ☐',
            'Бонус за аккуратную таблицу баланса: +1 ☐ / Balance-table bonus: +1 ☐',
            'Бонус за ясное объяснение баланса: +1 ☐ / Clear-balance-explanation bonus: +1 ☐',
            'Итого: ____ из 5 нимов. / Total ____ of 5 nims.',
            'Печать миссии (родитель): ☐ / Mission stamp (parent): ☐',
            'Подпись родителя: ____________________ / Parent signature'
          ]}
        ]
      }
    ]
  },
  parentGuide: {
    goal:
      'Сегодня сбалансированный день вокруг бюджета и счёта. Цель — показать: счёт — это запись, баланс — то, что осталось, и зачем записывать. / Balanced day around budget and account. Goal: show that an account is a record, balance is what remains, and why writing things down helps.',
    mathGoal:
      'Десятичные дроби (125.50 + 38.25 − 46.80 − 12.40 = 104.55), дробь от дохода (2/5 от 180, потом 1/3 от остатка → 72) и уравнение с процентом (1.15x = 92 → x = 80). / Decimals (= 104.55), fractions chained (→ 72), and a percent equation (→ 80).',
    russianGoal:
      'Парные согласные в корне; правильно записанный мини-диктант; исправлены 3–5 коротких предложений. / Paired consonants; correct mini-dictation; 3–5 short sentences corrected.',
    readingWritingGoal:
      'План из 3 пунктов; пересказ родителю; 3–5 предложений на русском по теме «зачем записывать доходы и расходы». / 3-point plan; retell to a parent; 3–5 Russian sentences on the topic.',
    practicalGoal:
      'Карточки тропы разложены; ребёнок прошёл тропу из 5 шагов от 40 нимов; две коробочки заполнены и есть правило проверки. / Path cards sorted; 5-step path from 40 nims walked; two boxes filled with a check rule.',
    observationGoal:
      'Ребёнок видит закономерность: «пришло» — баланс растёт, «ушло» — уменьшается, запись помогает не потерять счёт. / Child sees the pattern: "in" → balance grows; "out" → shrinks; record helps not to lose track.',
    check: [
      'Q1: 104.55 нимов (десятичный баланс). Q2: 72 нима (2/5 + 1/3 цепочкой). Q3: x = 80 нимов (1.15x = 92). / Q1: 104.55. Q2: 72. Q3: 80.',
      'Мини-диктант записан без грубых ошибок. / Mini-dictation OK.',
      'План текста — 3 пункта; пересказ — 3–5 предложений по-русски. / Plan = 3 points; retell = 3–5 Russian sentences.',
      'Карточки разложены по 4 корзинам (пришло/ушло/отложить/проверить). / Cards sorted into 4 baskets.',
      'Тропа баланса 5 шагов от 40 нимов посчитана без ошибок. / 5-step path from 40 nims is correct.',
      'Две коробочки заполнены, есть правило проверки баланса. / Two boxes filled with a check rule.',
      'Дневник мышления заполнен; есть открытие про баланс. / Thinking diary has a balance insight.'
    ],
    answerKey: [
      { taskId: 'q_w1', answer: 'Answer: 15.75 нимов. Solution: 12.5 + 7.5 = 20; 20 − 4.25 = 15.75. Parent note: десятичные складываем по столбику; вычитание с заёмом. / Decimal warm-up.' },
      { taskId: 'q_w2', answer: 'Answer: 6 нимов. Solution: 0.75 × 8 = 6 (или 3/4 × 8 = 6). Parent note: 0.75 = 3/4 — полезный мост между дробью и десятичной. / 0.75 × 8 = 6.' },
      { taskId: 'q1', answer: 'Answer: 104.55 нимов. Solution: 125.50 + 38.25 = 163.75; 46.80 + 12.40 = 59.20; 163.75 − 59.20 = 104.55. Parent note: сначала сложить ВСЕ приходы, потом ВСЕ расходы, потом одно вычитание — так меньше ошибок. / Steps: 163.75 − 59.20 = 104.55.' },
      { taskId: 'q2', answer: 'Answer: 72 нима. Solution: 2/5 × 180 = 72 → отложено; остаток 180 − 72 = 108; 1/3 × 108 = 36 → материалы; конечный остаток 108 − 36 = 72. Parent note: вторая дробь берётся от ОСТАТКА (108), а не от исходных 180. / Watch: 1/3 of remainder, not of 180.' },
      { taskId: 'q3', answer: 'Answer: 80 нимов. Solution: x + 0.15x = 92 → 1.15x = 92 → x = 92 ÷ 1.15 = 80. Parent note: «цена + 15% от цены» = та же цена ×1.15. Проверка: 80 × 1.15 = 92. / Check: 80 × 1.15 = 92.' },
      { taskId: 'q_s1', answer: 'Answer: 25 нимов. Solution: 250 ÷ 10 = 25. Parent note: «одна десятая» = деление на 10. / 1/10 of 250 = 25.' },
      { taskId: 'q_s2', answer: 'Answer: 15 нимов. Solution: 10% × 200 = 20; 5% = 10; 7.5% = 15 (или 7.5/100 × 200 = 15). Parent note: рассуждать через «10% + 5% − 2.5%». / 7.5% of 200 = 15.' },
      { taskId: 'q4', answer: 'Answer: рыбка — звонкая «б» (проверка: рыбы); ложка — глухая «ж→ш» (проверка: ложечка — звонкая); шапка — глухая «п» (шапочка); книга — звонкая «г» (книги); снежинка — глухая «ж→ш» (снег — звонкая); остаток — глухая «т» (остаточек). Solution: парная согласная в корне проверяется гласной (после согласной). Parent note: важно обсудить, что у «ложка»/«снежинка» проверочное слово даёт звонкую — это типичная ловушка. / Paired consonants by check word.' },
      { taskId: 'q5', answer: 'Answer: «Баланс показывает, сколько нимов осталось. Если записывать доходы и расходы, легче делать выбор.» Solution: запятая после «осталось», точки. Parent note: ≤ 2 ошибок — нормально для возраста. / Mini-dictation: ≤ 2 errors acceptable.' },
      { taskId: 'q_corr', answer: 'Answer: «Баланс показывает, сколько нимов осталось. Если записывать доходы и расходы, легче делать выбор.» Solution: балланс→Баланс (одна «л» + заглавная); скольк→сколько (мягкий знак); асталось→осталось (проверка: остаться); Еслi→Если (русская «и»); дохады→доходы (проверка: доход); лекче→легче (проверка: лёгкий). Parent note: 6 ошибок — засчитывай ≥ 5/6. / Acceptance: ≥ 5/6.' },
      { taskId: 'q6', answer: 'Answer: 3-пунктовый план + 3–5 предложений. Solution: пример плана — 1) счёт = место для записи нимов; 2) баланс растёт при «пришло» и уменьшается при «ушло»; 3) запись помогает видеть, сколько осталось. Parent note: главное — мысль о роли записи, а не пересказ слово в слово. / 3-point plan; record makes balance visible.' },
      { taskId: 'q_obs', answer: 'Answer: «Пришло» — баланс растёт. «Ушло» — баланс уменьшается. Одинаково — правило: новый_баланс = старый_баланс ± изменение. Меняется — конкретное число и направление. Ошибка в примере: 30 + 10 = 40 (не 50). Solution: вывод — «Без записи легко ошибиться даже на простом шаге». Parent note: принимай вывод про связь «запись → точность». / Mistake spotted on step 1; record → accuracy.' },
      { taskId: 'q7', answer: 'Answer: Пришло — подарок 10, помощь по дому 8. Ушло — книга 18, закуска 6. Отложить — отложил 5 нимов. Проверить — сверил таблицу с итогом. Solution: «отложить» — это специальный «ушло» (нимы остаются у нас, но на цели). «Проверить» — это действие, а не движение нимов. Parent note: обсудите спорные случаи. / Sortings with reasoning.' },
      { taskId: 'q8', answer: 'Answer: открытый ответ. Solution: пример — «На каждый день: закуска и проезд (15 нимов). На цель: книга (25 нимов). Правило: после каждого шага считаю заново.» Parent note: критерии — обе коробочки заполнены; сумма ≤ 40; есть правило проверки. / Open answer; criteria.' },
      { taskId: 'q9', answer: 'Answer: открытый ответ, 3–5 предложений со словами: доход, расход, баланс, запись. Solution: пример — «Сегодня я понял: доходы и расходы меняют баланс. Запись помогает не потерять счёт. Я буду записывать.» Parent note: проверь, что все 4 слова реально использованы. / Open answer with required words.' }
    ],
    spellingCheck:
      'Парные согласные проверяются гласной. Принимать ответы с проверкой хотя бы 4 слов из 6. / Accept if at least 4 of 6 paired consonants are checked correctly.',
    readingCheck:
      'План — 3 пункта; пересказ по-русски без чтения с листа. / 3-point plan; retell in Russian without reading.',
    practicalCheck:
      'Тропа из 5 шагов посчитана без ошибок; две коробочки заполнены и итог не превышает старт. / 5-step path correct; two boxes filled; total within start amount.',
    observationCheck:
      'Ребёнок может назвать ошибку в подсказанной таблице (30 → +10 → 50 → −5 → 45 → +5 → 50: ошибка на последнем шаге, должно быть 50, всё верно — обсудите, что иногда ошибки нет, и это тоже наблюдение) и сделал короткий вывод. / Child finds a mistake in the sample table (or notes that the table is correct) and writes a short conclusion.',
    discussionPrompts: [
      'Что такое доход, расход и баланс? / What are income, expense and balance?',
      'Почему мы записываем доходы и расходы? / Why do we write down income and expenses?',
      'Чем отличается коробка «на каждый день» от коробки «на цель»? / How is the everyday box different from the goal box?',
      'Что помогает не потерять счёт? / What helps us not to lose track?'
    ],
    ifEasy:
      'Дай тропу из 7 шагов и попроси самостоятельно нарисовать таблицу баланса с заголовками «событие», «+/−», «остаток». / Give a 7-step path and ask the child to draw a balance table with columns "event", "+/−", "remaining".',
    ifDifficult:
      'Возьми реальные нимы-карточки (бумажки с числами). Двигай их по столу: «пришло» — добавляешь карточку, «ушло» — убираешь. После каждого шага считайте остаток вместе. / Use paper nim-cards. "In" — add a card; "out" — remove. Count remaining together after each step.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 3,
    max: 5,
    label: 'Награда за миссию',
    display: '3 нима',
    bonuses: [
      { id: 'balance-table', label: 'Бонус за аккуратную таблицу баланса', amount: 1 },
      { id: 'clear-balance-explanation', label: 'Бонус за ясное объяснение баланса', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: ['q1', 'q4', 'q6', 'q7', 'q9'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'max-week-1-day-3'
};

export default day2;
